import { ReportingPeriodType } from '/src/lib/models';

/**
 * List Reporting Period Types
 */
// export type TListReportingPeriodTypesRequest = {};

export type TListReportingPeriodTypesResponse = ReportingPeriodType[];
